<manage-wrapper
  *ngIf="!!entity"
  [canEditMain]="true"
  [entityTitle]="entity.name"
  [tabGroups]="tabGroups"
  [selectedTab]="selectedTab"
  [readOnly]="false"
  [hideLabels]="true"
  [deleteTitle]="'Delete this Sponsor Template'"
  [type]="'sponsor'"
  [titlePlaceholder]="'Sponsor template name...'"
  [backgroundColor]="'#41474F'"
  [dialogTitle]="'Clipboard Sponsor Details'"
  [canDuplicate]="false"
  (onDone)="exit()"
  (onChangeTab)="changeTab($event)"
  (saveTitle)="updateTitle($event)"
  (onDelete)="delete()"
>
  <ng-container *ngIf="!selectedTab || selectedTab?.id === 'details'">
    <div class="uploaders-holder">
      <image-uploader 
        [id]="entity.id"
        (newUrls)="changeImage($event, 'logo')"
        [immediate]="true" 
        [isLogo]="true"
        [isTemplate]="true"
        [displayType]="imageUploaderDisplayTypes.widePodLogo"
        [thumbUrl]="entity.logoUrl" 
        [photoUrl]="entity.fullLogoUrl"
        [eventId]="data.accountId"
        [type]="'sponsor'" 
        [subtype]="'logo'" 
        [placeholder]="'Add logo'" 
        [uploadText]="'UPLOAD LOGO'"
        [saveName]="entity.name"
      ></image-uploader>
    </div>

    <manage-social [links]="entity?.social" (saveLinks)="saveSocialLinks($event)"></manage-social>

    <h3 class="description-title">Description</h3>
    <joi-input class="description" [disabled]="false" [italicPlaceholder]="true" [(model)]="entity.description" [type]="'textarea'" [returnable]="true" [placeholder]="'Click to add sponsor description...'" (joiChange)="saveEntity()"></joi-input>

    <manage-call-to-action
      [entity]="entity"
      [ctaProp]="'callToAction'"
      [urlProp]="'callToActionUrl'"
      [readOnly]="false"
      (ctaDetailsChanged)="saveEntity()"
    ></manage-call-to-action>

    <hr class="big-rule"/>

    <manage-contact-details
      [entity]="entity"
      [entityName]="'Sponsor'"
      [nameProp]="'contactName'"
      [numberProp]="'contactNumber'"
      [emailProp]="'contactEmail'"
      [readOnly]="false"
      (contactDetailsChanged)="saveEntity()"
    ></manage-contact-details>

  </ng-container>
</manage-wrapper>